import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Diagnostic } from "@/components/Diagnostic";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  const [prefill, setPrefill] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-paper text-ink">
      <Toaster position="bottom-right" toastOptions={{ style: { fontFamily: "'IBM Plex Sans', sans-serif" } }} />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Diagnostic onPrefill={setPrefill} />
        <About />
        <Contact prefill={prefill} />
      </main>
      <Footer />
    </div>
  );
}

export default App;
